import * as React from 'react';
import { memo } from 'react';

import UIAsset from 'components/atoms/UIAsset';
import { CoachIsEnumType } from 'components/molecules/CoachSelector';

export type CoachProps = {
	gesture: string;
	coach: CoachIsEnumType;
	alt?: string;
};

export const Coach = ({ gesture, coach, alt }: CoachProps) => {
	const uiClasses = ['a-coach'];

	return (
		<UIAsset
			className={uiClasses.join(' ')}
			src={`img/svg/coach/${gesture}-${coach.toLowerCase()}.svg`}
			alt={alt}
		/>
	);
};

Coach.displayName = 'Coach';

export default memo(Coach, (prevProps, nextProps) => {
	return prevProps.gesture === nextProps.gesture && prevProps.coach === nextProps.coach;
});
